module.exports = __webpack_public_path__ + "static/media/fundInProces.b75da91a.svg";